import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AddStoreModal from "./AddStoreModal";
import AppButton from "../common/AppButton";

const NoStoreListFound: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const [openAddModal, setOpenAddModal] = useState(false);

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh"
      }}
    >
      <Typography variant="h5" fontWeight="bold" mb={2}>
        {t("no-store-found", "No Store found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "no-store-description",
          "It looks like there are no stores in your company yet."
        )}
        <br />
        {t("no-store-cta", "Click below to add your first store.")}
      </Typography>

      <Box>
        <AppButton variant="primary" onClick={() => setOpenAddModal(true)}>
          {t("add-new-store", "Add new store")}
        </AppButton>
      </Box>

      <AddStoreModal
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
    </Box>
  );
};

export default NoStoreListFound;
